import { Typography as MUITypography, TypographyProps } from '@mui/material';
import { forwardRef } from 'react';

export const Text = forwardRef<HTMLElement, TypographyProps>(
  function Text(props, ref) {
    const { variant = 't1', color = 'inherit', ...args } = props;

    return (
      <MUITypography
        ref={ref}
        {...args}
        color={color ?? 'var(--ucr-palette-text-black)'}
        variant={variant}
      />
    );
  },
);
